export default "__VITE_ASSET__BMw4H1SO__"